// extracted by mini-css-extract-plugin
export default {"orgSelect":"navibar_orgSelect__W0Qcs","navItem":"navibar_navItem__7wzhv"};